import { useMeQuery } from '../api/me';

import type { Organization } from '../model/types/organization.dto';

const DEFAULT_ORGANIZATION_INFO_DATA = {
	organizations: [] as Organization[],
};

export const useOrganizations = () => {
	const { data = DEFAULT_ORGANIZATION_INFO_DATA, ...rest } = useMeQuery();
	return { organizations: data.organizations, ...rest };
};

export const useOrganization = (id: string) => {
	const { item: organization } = useMeQuery(undefined, {
		selectFromResult: ({ data }) => {
			return {
				item: data?.organizations?.find((item) => item.id === id),
			};
		},
	});

	return { organization };
};

export const useOrganizationsDictionary = (): Record<string, Organization> => {
	const { organizations } = useOrganizations();

	return organizations.reduce(
		(acc: Record<string, Organization>, curr) => ((acc[curr.id] = curr), acc),
		{}
	);
};

export const useParentOrganizations = () => {
	const { data, isFetching } = useMeQuery();

	return { organizations: data?.parentOrganizations ?? [], isFetching };
};
